import protoRoot from "../proto-root";
import CameraAndFlashlightState from "../private/CameraAndFlashlightState";

const name = "changeCameraRpcResponse";

function create({ cameraId, result }) {
  const ChangeCameraRpcResponse = protoRoot.lookupType(
    "comm.ChangeCameraRpcResponse"
  );
  const Result = protoRoot.lookupEnum("Result");

  const response = ChangeCameraRpcResponse.create({
    cameraAndFlashlightState: CameraAndFlashlightState.create({
      cameraId
    }),
    result: Result.values[result]
  });
  return { payload: response, name };
}

export default {
  create,
  name
};
